import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Typography from '@material-ui/core/Typography';


export class DashboardProjectDetails extends Component {

    render(){
        
        const {actualDate, plannedDate, detail} = this.props
        return(	
        <Card>
            <Grid item xs={12} sm container className="romis-card-header" style={{padding:10}}>
                <Grid item xs container direction="column" spacing={2}>
                    <Grid item xs>

                        <Typography variant="h5" component="h5" gutterBottom>
                            Project Details
               </Typography>

                    </Grid>
                </Grid>
                <Grid item>

                    <Typography className="clr-gray-2" variant="caption"><strong>Actual Date:</strong>{actualDate} </Typography>
                    <Typography variant="caption"> </Typography>
                    <Typography className="clr-gray-2" variant="caption"><strong>Planned Date:</strong> {plannedDate}</Typography>

                </Grid>
              </Grid>
    
            <CardContent>
                <Grid container spacing={3} >
                    <Grid item xs={12} sm container>
            
                        <Grid item xs container direction="column" spacing={2}>
                            <TextareaAutosize rows={4}
                                inputprops={{
                                readOnly: true,
                            }} 
                            value={detail} />

                    </Grid>
                
                </Grid>
                </Grid>
            </CardContent>
        </Card>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/DashboardProjectDetails.js